import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaDocumentoOrgaoEmissor = (): TabelaColuna => ({
  Chave: 'docIdentidade_OrgaoEmissor',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 100 }}>Doc. Identidade</div>
})
